import UXCatFooter from './UXCatFooter';

export default UXCatFooter;
